import { apiSlice } from "../../app/api/apiSlice";

export const menusApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMenus: builder.query({
      query: () => "/menus",
      transformResponse: (res) => res?.items || [],
    }),
  }),
});

export const { useGetMenusQuery } = menusApiSlice;
